import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import CoachingPlaylist from 'components/coaching/CoachingPlaylist';
import CoachingPlaylistStore, {PLAYLIST_MODE_TYPE} from 'stores/CoachingPlaylistStore';
import AuthStore from 'stores/AuthStore';
import CoachingPlanStore from 'stores/coaching/CoachingPlanStore';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import CoachingPlanActions from 'actions/coaching/CoachingPlanActions';
import isEmpty from 'lodash/isEmpty';
import {browserHistory} from 'react-router';
import {TYPE_COACHING_PLAN_COMPLETE} from 'components/ExpiredPage';
import {getQuery, getQueryParam} from 'utils/getQueryParam';
import UserStore from 'stores/UserStore';
import fetchMissingUsers from 'utils/fetchMissingUsers';
import {List} from 'immutable';
import {getDashboardPath} from 'components/StatsPage2.utils';
import InProgressReviewActions from 'actions/coaching/InProgressReviewActions';

@connectToStores
export default class CoachingPlaylistContainer extends React.PureComponent {
  static getStores() {
    return [CoachingPlaylistStore, AuthStore, CoachingPlanStore, UserStore];
  }

  static getPropsFromStores() {
    const store = CoachingPlaylistStore.getState();
    const plan = CoachingPlanStore.getState().planMap.get(store.planId);
    const review = plan && plan.getNextReview();
    const reviewCoach = review && UserStore.getState().users.get(review.coachUserId);

    return {
      visibility: store.visibility,
      mode: store.mode,
      sessionUser: AuthStore.getState().user,
      plan,
      storePlanId: store.planId,
      review,
      reviewCoach,
    };
  }

  componentDidMount() {
    if (this.checkForExpiredLink()) {
      return;
    }
    const sessionUser = AuthStore.getState().user;

    InProgressReviewActions.initialize(sessionUser);

    // Check if this playlist is being triggered by query params
    const {playlistMode, planId: queryPlanId} = getQuery(this.props.location);
    const planId = parseInt(queryPlanId, 10);

    // ALT
    setTimeout(async () => {
      // Disable until we can check the reviewType.
      CoachingPlaylistActions.setCanAddCalls(false);

      // Fetch coaching plans in case we're opening on a page without that info
      const plans = await CoachingPlanActions.fetchAll({
        coachId: sessionUser.id,
        recipientId: sessionUser.id,
        includeCompleted: false,
        includeReviews: true,
        includeReviewCoach: true,
      });

      const planInQuestion = plans.find(p => p.id === planId);

      if (playlistMode === PLAYLIST_MODE_TYPE.ADD_CALLS) {
        CoachingPlaylistActions.setAddCallsMode({
          planId,
          recipient: planInQuestion.recipient.info,
        });
      }

      const reviewInQuestion = planInQuestion && planInQuestion.getNextReview(false);
      reviewInQuestion && fetchMissingUsers(List([reviewInQuestion.coachUserId]));
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {plan, storePlanId} = this.props;
    // See if plan has loaded, or if plan changed.
    if ((!prevProps.plan && plan) || (prevProps.plan && plan && prevProps.plan.id !== plan.id)) {
      this.checkForExpiredLink();
    }

    // See if plan needs to be loaded.
    if (
      prevProps.storePlanId !== storePlanId &&
      storePlanId &&
      (!plan || plan.id !== storePlanId)
    ) {
      CoachingPlanActions.retrieve.defer(storePlanId, {
        includeReviews: true,
      });
    }
  }

  emailLink() {
    const {location} = this.props;
    const {query, pathname} = location;
    const {playlistMode, planId} = query;

    return playlistMode && planId && pathname.startsWith('/calls');
  }

  /**
   * Redirect to the expired page if the current plan is complete AND we're on the calls page with
   * the query params that open up the playlist.
   *
   * @return {boolean|*}
   */
  checkForExpiredLink() {
    const {plan} = this.props;
    // Plan must be present and completed.
    if (!plan || !plan.completed) {
      return false;
    }
    // User must have followed a link from an email.
    const emailLink = this.emailLink();
    if (emailLink) {
      // Replace, since back button would otherwise just bring you right back here to be
      // redirected again.
      browserHistory.replace(`/expired/${TYPE_COACHING_PLAN_COMPLETE}`);
    }
    return emailLink;
  }

  render() {
    const {location, sessionUser} = this.props;

    return (
      <CoachingPlaylist
        onCoachingTab={location.pathname.startsWith(getDashboardPath(sessionUser))}
        onCallsTab={location.pathname.startsWith('/calls') && isEmpty(location.search)}
        focusedCallId={getQueryParam(location, 'fileId')}
        {...this.props}
      />
    );
  }
}
